import { AlertTriangle, ArrowDownRight } from "lucide-react";
import { CIF } from "@/constants/testIds";

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid={CIF.problem}
      className="relative py-24 lg:py-32 bg-slate-950 text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-50 pointer-events-none" />
      <div className="absolute -top-40 left-1/4 h-[420px] w-[820px] bg-blue-500/10 rounded-full blur-3xl" />

      <div className="max-w-5xl mx-auto px-6 lg:px-10 relative">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10">
          <AlertTriangle className="h-3 w-3 text-amber-400" />
          <span className="text-[10px] tracking-[0.22em] uppercase font-bold text-amber-300">
            The Problem
          </span>
        </div>

        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-[-0.03em] leading-[1.05] mt-6 max-w-4xl">
          Buying without knowing your total cost is{" "}
          <span className="italic text-amber-300/90">risky</span>.
        </h2>

        <p className="mt-6 max-w-2xl text-[15px] lg:text-[16px] text-white/65 leading-relaxed">
          Most importers only know the FOB factory price when they commit. Freight, insurance and landed cost are estimated later — often after the PO is already issued. By then, margins are locked, alternatives are gone, and unexpected costs eat into the deal.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-3">
          {[
            { k: "01", t: "Hidden freight escalations", d: "Spot rates shift between RFQ and PO, but most buyers don't model it." },
            { k: "02", t: "Underestimated insurance", d: "Insurance is treated as an afterthought, distorting the real per-MT cost." },
            { k: "03", t: "Wrong purchasing decisions", d: "A cheaper FOB can become a costlier landed deal — and you only find out too late." },
          ].map((r) => (
            <div
              key={r.k}
              className="rounded-2xl bg-white/[0.04] border border-white/10 p-6 hover:bg-white/[0.06] hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-center justify-between">
                <span className="mono text-[11px] tracking-widest text-white/40">{r.k}</span>
                <ArrowDownRight className="h-4 w-4 text-amber-300/80" />
              </div>
              <div className="font-display text-lg font-medium mt-4">{r.t}</div>
              <div className="text-[13px] text-white/55 mt-2 leading-relaxed">{r.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;
